import React, { memo } from 'react'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'

function FormVendors__Details(props) {
    const { formik } = props

    return (
        <React.Fragment>
            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Purchase Order Name"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Purchase Order Name"} // placeholder for the input
                formikFieldName={"purchaseOrderName"} // important: formik value name for the input
            />

        </React.Fragment>
    )
}


export default memo(FormVendors__Details)